/**
 * Copyright lines are stored once, in site data, but they name a year that changes annually.
 * Baking the year into the stored string means the whole jobsite fleet needs a rebuild every
 * January just to move one digit, so the year is resolved at render instead.
 *
 * Two inputs are handled:
 *  - `{year}`, the token new site generation writes
 *  - a literal year after a copyright mark, which is what sites saved before the token exist
 *
 * Only the rendered output changes. The stored text is never rewritten.
 */

const COPYRIGHT_YEAR_TOKEN = "{year}",

  /** © / (c) / &copy;, then a year, optionally a dash and a second year. */
  COPYRIGHT_YEAR =
    /(©|&copy;|\(c\))(\s*)((?:19|20)\d{2})(\s*[–—-]\s*)?((?:19|20)\d{2})?/gi,

  /**
   * Replace the year in a copyright line with `year`. A range keeps its start year and moves
   * only the end ("© 2019 - 2026" → "© 2019 - 2027").
   */
  resolveCopyrightYear = (text: string, year: number): string => {
    if (!text) {
      return text;
    }

    return text
      .split(COPYRIGHT_YEAR_TOKEN)
      .join(String(year))
      .replace(COPYRIGHT_YEAR, (_match, mark, space, startYear, separator, endYear) => {
        if (separator && endYear) {
          return `${mark}${space}${startYear}${separator}${year}`;
        }

        return `${mark}${space}${year}`;
      });
  };

export { COPYRIGHT_YEAR_TOKEN, resolveCopyrightYear };
